import { useAppLogic } from 'modules/appLogic/useAppLogic';

export const AppLogic = () => {
  useAppLogic();
  return null;
};
